export default __webpack_public_path__ + "images/assets/6a047a4f731589ff965b01a76dd48960.svg";